/* @flow weak */
import Button from 'components/Button.jsx';
import Columns2 from 'components/Columns2.jsx';
import CurrentUser from 'auth/CurrentUser';
import EventTracking from 'lib/EventTracking';
import Fieldset from 'components/Fieldset.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import * as React from 'react';
import PasswordStrengthField from 'components/PasswordStrengthField.jsx';
import SettingsContainer from './SettingsContainer.jsx';
import ToastActions from 'actions/ToastActions';
import User from 'entities/User';
import UserActions from 'user/UserActions';

class UserPasswordForm extends React.Component<{}, $FlowFixMeState> {
  state = {
    canSubmit: false,
    passwordScore: null,
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  submit = (values: Object) => {
    const user: User = CurrentUser.getUser();
    const { passwordScore } = this.state;

    if (user.hasPassword()) {
      UserActions.changePassword(values.current_password, values.new_password)
        .then(() => {
          ToastActions.showSuccessToast('Password has been changed!');

          if (passwordScore !== null) {
            this.trackScore();
          }
        })
        .catch(ToastActions.showDefaultErrorToast);
    } else {
      UserActions.createPassword(values.new_password)
        .then(() => {
          ToastActions.showSuccessToast('Password has been set!');

          if (passwordScore !== null) {
            this.trackScore();
          }
        })
        .catch(ToastActions.showDefaultErrorToast);
    }
  };

  handleScoreUpdated = (passwordScore: number) => {
    this.setState({ passwordScore });
  };

  trackScore = () => {
    const { passwordScore } = this.state;
    EventTracking.track('password_strength', {
      password_score: passwordScore,
    });
  };

  render() {
    const user: User = CurrentUser.getUser();

    return (
      <Form onValid={this.enableButton} onValidSubmit={this.submit} onInvalid={this.disableButton}>
        <Fieldset legend="Password">
          <SettingsContainer>
            {user.hasPassword() && (
              <Columns2>
                <div>
                  <FormInput
                    label="Current password"
                    type="password"
                    className="UserPasswordForm-password"
                    name="current_password"
                    validations="minLength:6"
                    validOnPristine
                    validationError="Password must be at least 6 characters long."
                    required
                  />
                </div>
              </Columns2>
            )}
            <Columns2>
              <div>
                <PasswordStrengthField
                  name="new_password"
                  label="New password"
                  onScoreUpdated={this.handleScoreUpdated}
                />
              </div>
              <div>
                <FormInput
                  label="Retype password"
                  type="password"
                  autoComplete="new-password"
                  className="UserPasswordForm-password"
                  name="password_confirmation"
                  validations="equalsField:new_password"
                  validationError="Must be same as password"
                  validOnPristine
                />
              </div>
            </Columns2>
          </SettingsContainer>

          <Button size="small" type="submit" disabled={!this.state.canSubmit}>
            Save
          </Button>
        </Fieldset>
      </Form>
    );
  }
}

export default UserPasswordForm;
